import { ChangeDetectorRef, Component, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { RouterModule } from "@angular/router";
import { takeUntil } from "rxjs/operators";
import { RequestTrackerService } from "./core/services/request-tracker.service";
import { FirstyLoaderComponent } from "./core/components/firsty-loader/firsty-loader.component";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    imports: [
        RouterModule,
        FirstyLoaderComponent
    ]
})
export class AppComponent implements OnDestroy {
    private unsubscribe$: Subject<void> = new Subject<void>();

    isLoading = false;

    public constructor(
        public readonly requestTrackerService: RequestTrackerService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        this.requestTrackerService.requestCount$
            .pipe(takeUntil(this.unsubscribe$ as Subject<void>))
            .subscribe((count: number) => {
                if (!!count !== this.isLoading) {
                    this.isLoading = !!count;
                    this.changeDetectorRef.detectChanges();
                }
            });
    }

    public ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
